import styled from 'styled-components';

import NumberFormat from 'react-number-format';

export const NumberFormatInput = styled(NumberFormat)`
  height: 40px;
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.lightGray};
  text-align: left;
  color: #545454;
  &:focus {
    border: 1px solid ${(props) => props.theme.colors.gray};
    border-radius: 8px;
    color: #545454;
  }
`;

export const LabelInput = styled.label`
  font-weight: 600;
  color: #545454;
  font-size: 16px;
  width: 100%;
`;
